import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'b3';
import ReactTooltip from 'react-tooltip';
import { openStackedStep, completeWizard, openEmailForSelectedContact } from '../logActivityReducer';
import { EVALUATION_CLIENT_STAGE_ID } from '../../../constants/clientStages';

var ScheduleNextOrComplete = ({openStackedStep, completeWizard, client, openEmailForSelectedContact, participatingContactId, contacts, callDeterminedClientAsGoodFit}) => {
	var isInEvaluation = client.clientStageId == EVALUATION_CLIENT_STAGE_ID && callDeterminedClientAsGoodFit !== true;
	return (
		<div className="wizardStepActions">
			<div className="header">
				<h2>What would you like to do?</h2>
			</div>
			<div className="buttonsRow" style={{flexDirection: 'column'}}>
				<div style={{display: 'flex', marginBottom: 20}}>
					<Button onClick={e => {
						openStackedStep('ScheduleCallStep');
					}} type="success">Schedule Phone Call</Button>

					<Button disabled={isInEvaluation} onClick={e => {
						openStackedStep('BookMeetingStep');
					}} showTooltipFor="schedule-meeting-tooltip" type="success">Schedule Meeting</Button>

					{isInEvaluation &&
						<ReactTooltip mouseLeaveDelay={2000} visible={true} id="schedule-meeting-tooltip" place='top' effect='solid' type='dark'>
							<span className="shortcut-tooltip-label">
								Cannot schedule meeting with unqualified customer
							</span>
						</ReactTooltip>
					}

					<Button onClick={e => {
						openEmailForSelectedContact({contacts, participatingContactId})
					}} type="success">Send Email</Button>
				</div>
				<div style={{display: 'flex'}}>
					<Button className="completeBtn" onClick={completeWizard} type="primary">Complete</Button>
				</div>
			</div>
		</div>
	);
}

export default connect(
	state => ({
		client: state.activeClient.client,
		contacts: state.activeClient.contacts,
		participatingContactId: state.logActivityWizard.callData.participatingContactId,
		callDeterminedClientAsGoodFit: state.logActivityWizard.callData.callDeterminedClientAsGoodFit
	}),
	{ openStackedStep, completeWizard, openEmailForSelectedContact }
)(ScheduleNextOrComplete);





// WEBPACK FOOTER //
// ./app/components/schedule-wizard/actions/ScheduleNextOrComplete.js